
function product_carousel(){
  swiperProduct = new Swiper(".futter-image-slider-one", {
      pagination: {
        el: ".swiper-pagination",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      }
    });
}product_carousel();
function brand_carousel(){
  var swiper = new Swiper(".futter-brand-carousel", {
      slidesPerView: 2,
      loop: true,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
    });
}brand_carousel();
function help_btn(){
  $(window).scroll(function() {    
    var scroll = $(window).scrollTop();

    if (scroll >= 100) {
        $(".transparent-help-btn").addClass("help-btn");
    } else {
        $(".transparent-help-btn").removeClass("help-btn");
    }
});
}help_btn();
function scroll_to_section(){
$("#futterCatInfo").click(function() {
    $('html, body').animate({
        scrollTop: $("#futterCatInfoDiv").offset().top - 250 // Subtracting 200px offset
    }, 150);
});
}scroll_to_section();

/*===============Hover menu body add class===============*/
$(".header-layout-classic .list-menu--inline li.futter-sub-menu").hover(function(){
    $("body").addClass("overlay-background");
},function(){
    $("body").removeClass("overlay-background");
})



/*===============End Hover menu body add class===============*/

function banner_desc(){
  function toggleDescription() {
        const fullDesc = document.querySelector('.full-description');
        const truncatedDesc = document.querySelector('.truncated-description');
        const readMoreBtn = document.querySelector('.read-more-btn');

        if (truncatedDesc.style.display === 'none') {
            truncatedDesc.style.display = 'block';
            fullDesc.style.display = 'none';
            readMoreBtn.textContent = 'LESE WENIGER';
        } else {
            truncatedDesc.style.display = 'none';
            fullDesc.style.display = 'block';
            readMoreBtn.textContent = 'WEITER LESEN';
        }
    }

    // Event listener for the read more/less button
    if(document.querySelector('.read-more-btn'))
    {
      document.querySelector('.read-more-btn').addEventListener('click', toggleDescription);
    }
    
}banner_desc();


// function sticky_header(){
//   $(window).scroll(function() {    
//     var scroll = $(window).scrollTop();

//     if (scroll >= 100) {
//         $(".futter-sticky-header").addClass("stick-top");
//     } else {
//         $(".futter-sticky-header").removeClass("stick-top");
//     }
// });
// }sticky_header();


function waitForFacetFiltersForm(callback, retries = 20) {
  if (typeof FacetFiltersForm !== "undefined") {
      callback();
  } else if (retries > 0) {
      setTimeout(() => {
          waitForFacetFiltersForm(callback, retries - 1);
      }, 100);
  } else {
      console.warn("FacetFiltersForm not found after waiting.");
  }
}


waitForFacetFiltersForm(() => {
    const originalRenderSectionFromFetch = FacetFiltersForm.renderSectionFromFetch;
    
    FacetFiltersForm.renderSectionFromFetch = async function(url, event) {
        const isAjaxSectionLoad = url.includes("section_id=");
        console.log('urlurlurl',url)
        await originalRenderSectionFromFetch.call(this, url, event);

        setTimeout(() => {
          $(".futter-product-content").hide();
          $(".futter-product-content").slice(0, 12).show();   
          if ($(".futter-product-content").length > 12) {
            $("#loadMore").show();
          } else {
            $("#loadMore").hide();
          }
          $("#loadMore").on("click", function(e){
            e.preventDefault();
            $(".futter-product-content:hidden").slice(0, 6).slideDown();
            if ($(".futter-product-content:hidden").length == 0) {
              $("#loadMore").text("No Content").addClass("noContent");
            }
          });
         
        }, 1000);
    };

    const originalCache = FacetFiltersForm.renderSectionFromCache;

    FacetFiltersForm.renderSectionFromCache = function(filterDataFunc, event) {
        console.log("[HOOK] Cache hit — using cached HTML", filterDataFunc);
        //originalCache.call(this, filterDataFunc, event);
        originalCache.apply(FacetFiltersForm, [filterDataFunc, event]);

        setTimeout(() => {
          $(".futter-product-content").hide();
          $(".futter-product-content").slice(0, 12).show();   
          if ($(".futter-product-content").length > 12) {
            $("#loadMore").show();
          } else {
            $("#loadMore").hide();
          }
          $("#loadMore").on("click", function(e){
            e.preventDefault();
            $(".futter-product-content:hidden").slice(0, 6).slideDown();
            if ($(".futter-product-content:hidden").length == 0) {
              $("#loadMore").text("No Content").addClass("noContent");
            }
          });
        
        }, 2000);
    };
});








let selectedSamples = [];
let addedSamples = [];
let lastCartHash = '';
let cartSyncInterval = null;


/* =========================
   BUTTON TEXT UPDATE
========================= */
function updateButtonText() {

  document.querySelectorAll('.overlay .prod-add-btn').forEach(btn => {
    const variantId = parseInt(btn.dataset.id);

    if (addedSamples.includes(variantId)) {
     
      btn.innerText = "✓ Im Warenkorb";
      btn.disabled = true;

    } else if (selectedSamples.includes(variantId)) {
     
      btn.innerText = "✓ Im Warenkorb";
      btn.disabled = false; 

    } else {
      
      btn.innerText = "In den Warenkorb";
      btn.disabled = false;
    }

  });
}

/* =========================
   INTERVAL CONTROL
========================= */
function startCartSync(){
 if(cartSyncInterval) return;

 cartSyncInterval = setInterval(autoCartSync, 2000);
}

function stopCartSync(){
 if(cartSyncInterval){
   clearInterval(cartSyncInterval);
   cartSyncInterval = null;
 }
}

/* =========================
   POPUP OPEN / CLOSE
========================= */
function openLightbox(){
 document.getElementById('overlay').style.display='flex';
 fetchCartAndSync();
 startCartSync(); 
 updateButtonText();

}

function closeLightbox(){
 document.getElementById('overlay').style.display='none';
 stopCartSync(); 
}

function handleOverlayClick(e){
 if(e.target.id === 'overlay'){
   closeLightbox();
 }
}

/* =========================
   CART SYNC (ONLY SAMPLES)
========================= */
function fetchCartAndSync(){

 return fetch('/cart.js')
 .then(res=>res.json())
 .then(cart=>{

   let cartIds = cart.items
     .map(item => item.id)
     .filter(id => window.sampleProductIds.includes(id));

   addedSamples = [...new Set(cartIds)];

   document.querySelectorAll('.product-card').forEach(card=>{
     card.classList.remove('added');
   });

   addedSamples.forEach(id=>{
     let btn = document.querySelector(
       '.prod-add-btn[data-id="'+id+'"]'
     );
     if(btn){
       btn.closest('.product-card').classList.add('added');
     }
   });

   updateCount();

   return cart;
 });
}

/* =========================
   AUTO CART SYNC
========================= */
function autoCartSync(){

 fetch('/cart.js')
 .then(res=>res.json())
 .then(cart=>{

   let hash = cart.items.map(i=>i.id+':'+i.quantity).join('|');

   if(hash !== lastCartHash){

     lastCartHash = hash;

     fetchCartAndSync();
     updateCartUI();

   }

 });
}

/* =========================
   SELECT SAMPLE
========================= */
function toggleSample(variantId, btn){

 let card = btn.closest('.product-card');
 let total = addedSamples.length + selectedSamples.length;

 

 //  if already in cart → do nothing
 if(addedSamples.includes(variantId)) return;

 if(selectedSamples.includes(variantId)){
   selectedSamples = selectedSamples.filter(id=>id!=variantId);
   card.classList.remove('added');

 } else {

   if(total >= 1){
     alert('Nur ein Geschenk pro Bestellung');
     return;
   }

   selectedSamples.push(variantId);
   card.classList.add('added');
 }

 updateCount();
 updateButtonText();
}


/* =========================
   COUNT
========================= */
function updateCount(){

 let total = addedSamples.length + selectedSamples.length;
 if(total > 1) total = 1;

 let el = document.getElementById('selected-count');
 if(el){
   el.innerText = total + ' von 1 Proben ausgewählt';
 }
}

/* =========================
   ADD TO CART
========================= */
function addSelectedSamplesToCart(e){

 if(e) e.preventDefault();
 if(!selectedSamples.length) return;

 fetch('/cart/add.js',{
   method:'POST',
   headers:{ 'Content-Type':'application/json' },
   body:JSON.stringify({
     items:selectedSamples.map(id=>({
       id:id,
       quantity:1
     }))
   })
 })
 .then(()=>{
   selectedSamples = [];
   return fetchCartAndSync();
 })
 .then(()=>{
   closeLightbox();
   updateCartUI();
   openCartDrawer();
 })
 .catch(err=>console.error(err));
}

/* =========================
   CART UI UPDATE (ALL)
========================= */
function updateCartUI(){

 // HEADER COUNT
 fetch('/cart.js')
 .then(res=>res.json())
 .then(cart=>{

   document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]')
   .forEach(el=>{
     el.innerText = cart.item_count;
   });

   document.querySelectorAll('.cart-count-bubble .visually-hidden')
   .forEach(el=>{
     el.innerText = cart.item_count + ' Artikel';
   });

 });

 // SECTION RENDER
 fetch('/?sections=cart-drawer,main-cart-items')
 .then(res=>res.json())
 .then(data=>{

   let drawer = document.querySelector('#CartDrawer-CartItems');
   if(drawer && data['cart-drawer']){
     let html = new DOMParser()
       .parseFromString(data['cart-drawer'], 'text/html')
       .querySelector('#CartDrawer-CartItems');
     if(html) drawer.innerHTML = html.innerHTML;
   }

   let cartPage = document.querySelector('#main-cart-items');
   if(cartPage && data['main-cart-items']){
     let html = new DOMParser()
       .parseFromString(data['main-cart-items'], 'text/html')
       .querySelector('#main-cart-items');
     if(html) cartPage.innerHTML = html.innerHTML;
   }

 });
}

/* =========================
   OPEN DRAWER
========================= */
function openCartDrawer(){
 let drawer = document.querySelector('cart-drawer');
 if(drawer && drawer.open){
   drawer.open();
 }
}

/* =========================
   OPTIONAL: VISIBILITY OPTIMIZATION
========================= */
document.addEventListener("visibilitychange", function(){
 if(document.hidden){
   stopCartSync();
 } else {
   startCartSync();
 }
});

